import { motion } from "framer-motion";
import {
  Target,
  Heart,
  Zap,
  Users,
  TrendingUp,
  Shield,
  Award,
  Clock,
} from "lucide-react";

const AboutPage = () => {
  const values = [
    {
      icon: Target,
      title: "ROI Odaklı",
      desc: "Her stratejimiz yatırım getirisini maksimize etmeye odaklıdır.",
    },
    {
      icon: Heart,
      title: "Müşteri Öncelikli",
      desc: "Müşterilerimizin başarısı bizim başarımızdır.",
    },
    {
      icon: Zap,
      title: "Hızlı Aksiyon",
      desc: "Fırsatları kaçırmadan hızlıca harekete geçeriz.",
    },
    {
      icon: Shield,
      title: "%100 Şeffaflık",
      desc: "Tüm süreçlerde açık ve dürüst iletişim.",
    },
  ];

  const whyUs = [
    {
      icon: Award,
      title: "Tecrübeli Ekip",
      desc: "Dijital pazarlama alanında uzman ekibimizle yanınızdayız.",
    },
    {
      icon: TrendingUp,
      title: "Kanıtlanmış Sonuçlar",
      desc: "Onlarca başarılı proje ve mutlu müşteri.",
    },
    {
      icon: Users,
      title: "Kişisel İlgi",
      desc: "Her müşterimize özel strateji ve birebir ilgi.",
    },
    {
      icon: Clock,
      title: "7/24 Destek",
      desc: "İhtiyaç duyduğunuzda her zaman ulaşılabilir.",
    },
  ];

  return (
    <div className="pt-20">
      {/* Hero */}
      <section className="py-24 bg-gradient-to-br from-purple-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-purple-600 mb-4">
                HAKKIMIZDA
              </p>
              <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-slate-900 font-['Outfit'] mb-6">
                Bir dijital ajanstan <span className="text-gradient">çok daha fazlasıyız</span>
              </h1>
            <p className="text-lg text-slate-600 leading-relaxed mb-6">
                Roi Bilişim olarak, küçük ve orta ölçekli işletmelerin dijital dünyada 
                büyümesine yardımcı oluyoruz. ROI odaklı yaklaşımımızla, her kuruşunuzun 
                karşılığını almanızı sağlıyoruz.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                <strong>Markanız için mükemmel deneyimler sunuyoruz.</strong> Stratejik 
                yaklaşımımız, web tasarım, dijital reklamcılık ve SEO alanlarında uzman 
                ekibimiz tarafından desteklenmektedir.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative"
            >
              <img
                src="https://images.pexels.com/photos/7108209/pexels-photo-7108209.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Team Meeting"
                className="rounded-3xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6">
                <p className="text-4xl font-black text-gradient font-['Outfit']">50+</p>
                <p className="text-slate-600 text-sm">Mutlu Müşteri</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-24" data-testid="story-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://images.pexels.com/photos/7108269/pexels-photo-7108269.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Office"
                className="rounded-3xl shadow-xl"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-purple-600 mb-4">
                HİKAYEMİZ
              </p>
              <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Outfit'] mb-6">
                Dijital dünyada <span className="text-gradient">çözüm ortağınız</span>
              </h2>
              <div className="space-y-4 text-slate-600 leading-relaxed">
                <p>
                  Web sitesi olmayan veya dijital varlığı zayıf küçük işletmelerin potansiyellerini 
                  fark edemediklerini gördük. Bu sorunu çözmek için yola çıktık.
                </p>
                <p>
                  Bugün, onlarca işletmenin dijital dönüşümüne öncülük ediyoruz. Web sitesi kurulumu, 
                  Google Ads yönetimi ve SEO hizmetleri ile müşterilerimizin büyümesine katkı sağlıyoruz.
                </p>
                <p>
                  <strong>Biz sadece bir dijital pazarlama ajansı değiliz, ekibinizin bir parçasıyız.</strong>
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 bg-slate-50" data-testid="values-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-purple-600 mb-4">
              DEĞERLERİMİZ
            </p>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Outfit']">
              Bizi <span className="text-gradient">farklı kılan</span> değerler
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="p-6 rounded-2xl bg-white border border-slate-100 shadow-sm hover:shadow-md transition-all"
                data-testid={`value-${index + 1}`}
              >
                <div className="p-3 rounded-xl bg-purple-50 text-purple-600 inline-block mb-4">
                  <value.icon size={24} />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 mb-2 font-['Outfit']">
                  {value.title}
                </h3>
                <p className="text-sm text-slate-600">{value.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Us */}
      <section className="py-24" data-testid="why-us-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-purple-600 mb-4">
              NEDEN BİZ
            </p>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Outfit']">
              Olağanüstü sonuçlar sunmaya <span className="text-gradient">kendini adamış</span> bir ajans
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8">
            {whyUs.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex gap-4 p-6 rounded-2xl bg-slate-50"
              >
                <div className="p-3 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 text-white h-fit">
                  <item.icon size={24} />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-slate-900 mb-2 font-['Outfit']">
                    {item.title}
                  </h3>
                  <p className="text-slate-600">{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
